import { FC } from "react";
import { useDispatch } from "react-redux";

import { CollaboratorRole, ICollaborator } from "./../../../../store/collaborators/types";
import { changeCollaboratorRole, deleteCollaborator } from "../../../../store/collaborators/actionCreators";
import { IconTypes } from "./../../../../libs/Icon";
import Dropdown from "./../../Dropdown";

interface IProps {
    id: ICollaborator["id"];
    role: CollaboratorRole;
    scrolled: boolean;
    clearScrolled: () => void;
}

const RoleButton: FC<IProps> = ({ id, role, scrolled, clearScrolled }) => {
    const dispatch = useDispatch();

    const onRemove = () => {
        dispatch(deleteCollaborator({ id: id }));
    };

    const onChange = (newValue: CollaboratorRole) => {
        dispatch(changeCollaboratorRole({ id: id, newRole: newValue }));
    };

    const isEditor = role === CollaboratorRole.Editor;

    return (
        <Dropdown
            icon={isEditor ? IconTypes.EDIT : IconTypes.EYE}
            text={isEditor ? "Editor" : "Viewer"}
            onRemove={onRemove}
            scrolled={scrolled}
            currentRole={role}
            clearScrolled={clearScrolled}
            onChange={onChange}
        />
    );
};

export default RoleButton;
